import { Link } from 'react-router-dom';

export default function LPFooter() {
  return (
    <footer className="border-t border-zinc-200 bg-white" data-testid="lp-footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-zinc-500 font-body" data-testid="lp-footer-copyright">
          &copy; 2026 AmericanTrademark Firm. All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-xs" data-testid="lp-footer-legal">
          <Link to="/privacy-policy" className="text-zinc-500 hover:text-[#002FA7] transition-colors font-body">
            Privacy Policy
          </Link>
          <span className="text-zinc-300">|</span>
          <Link to="/terms-of-service" className="text-zinc-500 hover:text-[#002FA7] transition-colors font-body">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
}
